import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-users-new',
    template: `
    <p>
      user-new works!
    </p>
  `,
    styles: []
})
export class UsersNewComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/users/users-new/users-new.component.ts